var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 17,
    height: 18,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 10,
    height: 3,
    rx: 1,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11,
    r: 1.2,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 1.2,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 11,
    r: 1.2,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 15,
    r: 1.2,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15,
    r: 1.2,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 15,
    r: 1.2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.b240f7fc25b614668404b35df900818e.svg";
export { ForwardRef as ReactComponent };